var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "loginbg", attrs: { id: "login-main-hr" } }, [
    _c("div", { staticClass: "container" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-sm-9 col-md-7 col-lg-5 mx-auto" }, [
          _c("div", { staticClass: "loginform" }, [
            _c("div", { staticClass: "loginlogo" }, [
              _c("img", {
                attrs: { src: _vm.logoPath, alt: "Velocity Vehicle Group" }
              })
            ]),
            _vm._v(" "),
            _c("form", [
              _c("div", { staticClass: "form-group" }, [
                _c("label", { attrs: { for: "exampleInputEmail1" } }, [
                  _vm._v("Username")
                ]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.username,
                      expression: "username"
                    }
                  ],
                  staticClass: "form-control",
                  attrs: {
                    type: "text",
                    name: "username",
                    id: "username_login",
                    placeholder: "Enter Username"
                  },
                  domProps: { value: _vm.username },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.username = $event.target.value
                    }
                  }
                }),
                _vm._v(" "),
                _c("span", { staticClass: "help is-danger" }, [
                  _vm._v(_vm._s(_vm.username_error_msg))
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _c("label", { attrs: { for: "exampleInputPassword1" } }, [
                  _vm._v("Password")
                ]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.password,
                      expression: "password"
                    }
                  ],
                  staticClass: "form-control",
                  attrs: {
                    type: "password",
                    name: "password",
                    id: "password_login",
                    placeholder: "Enter password"
                  },
                  domProps: { value: _vm.password },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.password = $event.target.value
                    }
                  }
                }),
                _vm._v(" "),
                _c("span", { staticClass: "help is-danger" }, [
                  _vm._v(_vm._s(_vm.password_error_msg))
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "help is-danger" }, [
                _vm._v(_vm._s(_vm.error_msg_login))
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-check not-registered" }),
              _vm._v(" "),
              _c("div", [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-primary",
                    attrs: {
                      disabled: _vm.disableButtons.loginButton,
                      id: "loginbtn",
                      type: "submit"
                    },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.login(this)
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.buttonNames.loginButton))]
                )
              ])
            ])
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-657094ba", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-657094ba","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Login/Login.vue
// module id = null
// module chunks = 